import { Box, Container, Typography, Paper, Grid, IconButton, Avatar, Card, CardContent } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

const mockRecommended = [
  { name: 'Aarav', age: 28, location: 'Hyderabad' },
  { name: 'Priya', age: 26, location: 'Chennai' },
  { name: 'Rahul', age: 30, location: 'Bangalore' },
];

const Recommended = () => {
  const navigate = useNavigate();
  return (
    <Box sx={{ minHeight: '100vh', background: 'linear-gradient(135deg, #FFF0F5 0%, #FFE4E1 100%)', py: 6, position: 'relative' }}>
      {/* Navigation Buttons */}
      <Box sx={{ position: 'absolute', top: 20, left: 20, zIndex: 10, display: 'flex', gap: 2 }}>
        <IconButton onClick={() => navigate('/')} sx={{ bgcolor: 'rgba(255,255,255,0.9)', '&:hover': { bgcolor: 'white', transform: 'scale(1.1)' }, boxShadow: '0 2px 10px rgba(0,0,0,0.1)', transition: 'all 0.3s' }}>
          <HomeIcon sx={{ color: '#FF4B91' }} />
        </IconButton>
        <IconButton onClick={() => navigate(-1)} sx={{ bgcolor: 'rgba(255,255,255,0.9)', '&:hover': { bgcolor: 'white', transform: 'scale(1.1)' }, boxShadow: '0 2px 10px rgba(0,0,0,0.1)', transition: 'all 0.3s' }}>
          <ArrowBackIcon sx={{ color: '#FF4B91' }} />
        </IconButton>
      </Box>
      <Container maxWidth="md" sx={{ position: 'relative', zIndex: 1 }}>
        <Paper elevation={3} sx={{ p: 4, borderRadius: '16px', background: 'rgba(255,255,255,0.95)', mt: 8 }}>
          <Typography variant="h4" fontWeight={700} color="#FF4B91" mb={3}>Recommended Users</Typography>
          <Grid container spacing={2}>
            {mockRecommended.map((user, idx) => (
              <Grid item xs={12} sm={4} key={idx}>
                <Card sx={{ borderRadius: 3, boxShadow: 2 }}>
                  <CardContent sx={{ textAlign: 'center' }}>
                    <Avatar sx={{ width: 56, height: 56, mx: 'auto', mb: 1 }} />
                    <Typography variant="h6">{user.name}</Typography>
                    <Typography variant="body2">Age: {user.age}</Typography>
                    <Typography variant="body2">Location: {user.location}</Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Paper>
      </Container>
    </Box>
  );
};

export default Recommended; 